import { useQuery as i } from "react-query";
import { useEnvironment as m } from "../../common/hooks/environment/useEnvironment.js";
import { getAdapter as c } from "../../api/adapter.js";
import { CustomizationAdapter as u } from "../models/customization/customization.adapter.js";
function w(a) {
  const {
    backendBaseUrl: r
  } = m();
  return i("landing", async ({
    signal: e
  }) => {
    const t = new URL(`${r}/configuration/landing-page-data/?domain_name=${a}`), n = new URL(window.location.toString()).searchParams.get("t");
    n !== null && t.searchParams.set("t", n);
    const o = await fetch(t, {
      signal: e
    });
    if (o.status !== 200)
      throw new Error("Error");
    const s = await o.json();
    return c(u).adapt(s);
  }, {
    refetchOnWindowFocus: !1
  });
}
export {
  w as default
};
//# sourceMappingURL=useDomainCustomization.js.map
